import api from '../ApiService';
import auth from '../AuthService';

const updateUserProfilePicture = async (fileId) => {
  await auth.put('/me/profilePicture', JSON.stringify({ profilePicture: { fileId } }));
};

const createNewFile = async (user) => {
  const { data: file } = await api.post('/file', {
    filename: `users/${user.email}/${user.firstName}_${user.lastName}.webp`,
    size: 1000,
  });
  if (file.acknowledged) {
    const fileId = file.insertedId;
    await updateUserProfilePicture(fileId);
    return fileId;
  }
  return null;
};

export default createNewFile;
